import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ORDER_SERVER_URL } from '../../config';
import { FieldOfOrderAggregate, OrderAggregate } from '../../order/models/aggregation/order-aggregate';

const GET_ORDERS_URL = `${ ORDER_SERVER_URL }/v4/orders`;

@Injectable({ providedIn: 'root' })
export class OrdersService {
	constructor(
		private readonly http: HttpClient,
	) {}

	getOrderAggregateQuantity(
		fields: readonly FieldOfOrderAggregate[],
		filter?: string
	) {
		const url = new URL(`${ GET_ORDERS_URL }:aggregateQuantity`);
		const params = url.searchParams;

		params.append('fields', fields.join(','));

		if (filter) {
			params.append('filter', filter);
		}

		return this.http.get<OrderAggregate[]>(url.toString());
	}
}
